import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useFilterStore = defineStore('filters', () => {
  const isDTSActive = ref<boolean>(true)
  const isDASActive = ref<boolean>(true)
  const isDoBActive = ref<boolean>(true)
  const isVesselActive = ref<boolean>(true)

  const isFishingActive = ref<boolean>(true)
  const isCargoActive = ref<boolean>(true)
  const isTankerActive = ref<boolean>(true)
  const isUnderwaterActive = ref<boolean>(true)
  const isDivingActive = ref<boolean>(true)
  const isPassengerActive = ref<boolean>(true)
  const isOtherActive = ref<boolean>(true)
  const isUnknownActive = ref<boolean>(true)

  const setDTS = () => {
    isDTSActive.value = !isDTSActive.value
  }

  const setDoB = () => {
    isDoBActive.value = !isDoBActive.value
  }

  const setDAS = () => {
    isDASActive.value = !isDASActive.value
  }

  const setVessel = () => {
    isVesselActive.value = !isVesselActive.value
  }

  const setFishing = () => {
    isFishingActive.value = !isFishingActive.value
  }

  const setCargo = () => {
    isCargoActive.value = !isCargoActive.value
  }

  const setTanker = () => {
    isTankerActive.value = !isTankerActive.value
  }

  const setUnderwater = () => {
    isUnderwaterActive.value = !isUnderwaterActive.value
  }

  const setDiving = () => {
    isDivingActive.value = !isDivingActive.value
  }

  const setPassenger = () => {
    isPassengerActive.value = !isPassengerActive.value
  }

  const setOther = () => {
    isOtherActive.value = !isOtherActive.value
  }

  const setUnknown = () => {
    isUnknownActive.value = !isUnknownActive.value
  }

  return {
    isDTSActive,
    isDASActive,
    isDoBActive,
    isVesselActive,
    isFishingActive,
    isCargoActive,
    isTankerActive,
    isUnderwaterActive,
    isDivingActive,
    isPassengerActive,
    isOtherActive,
    isUnknownActive,
    setDTS,
    setDAS,
    setDoB,
    setVessel,
    setFishing,
    setCargo,
    setTanker,
    setUnderwater,
    setDiving,
    setPassenger,
    setOther,
    setUnknown
  }
})
